"use strict";
// @ts-ignore
try {
    self['workbox:google-analytics:7.0.0'] && _();
}
catch (e) { }
